module.exports = __webpack_public_path__ + "img/DSC_7319_2.d3a4a2ee.jpg";